const json = async (res: Response): Promise<any> => {
  if (res.ok) {
    return res.json();
  }
  const text = await res.text();
  return await Promise.reject(JSON.parse(text));
};

export default json;
